var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"canvasWrapper"}},[_c('canvas',{attrs:{"height":"100vh","width":"100vw","id":"canvas"},on:{"mousedown":_vm.startPainting,"mouseup":_vm.finishedPainting,"touchstart":_vm.touchStart,"touchend":_vm.touchEnd,"touchmove":_vm.touchMove,"mousemove":_vm.draw}})])
}
var staticRenderFns = []

export { render, staticRenderFns }